import { useTranslation } from "react-i18next";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

interface DeleteConfirmationDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  selectedCount: number;
}

export const DeleteConfirmationDialog = ({
  open,
  onOpenChange,
  onConfirm,
  selectedCount,
}: DeleteConfirmationDialogProps) => {
  const { t } = useTranslation();

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="text-[#34375B]">{t("invoices.deleteConfirmation.title")}</AlertDialogTitle>
          <AlertDialogDescription className="font-thin text-[#34375B]/70">
            {t("invoices.deleteConfirmation.description", { count: selectedCount })}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="text-[#636782] hover:text-[#34375B] hover:bg-transparent hover:shadow-[4px_4px_0px_0px_#34375B] hover:-translate-x-[1px] hover:-translate-y-[1px] transition-all duration-200">{t("invoices.deleteConfirmation.cancel")}</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            className="bg-destructive/70 text-destructive-foreground hover:bg-destructive hover:shadow-[4px_4px_0px_0px_#34375B] hover:-translate-x-[1px] hover:-translate-y-[1px] transition-all duration-200"
          >
            {t("invoices.deleteConfirmation.confirm")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};